<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'customer' }" ripple>{{ $t('customer_list') }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentView: 'customer'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Tremendous/MainMenu.vue